import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Column, ColumnGroup } from '@cards/Card';
import { usePageActions } from '@hooks';
import {
  inviteDirectChildOrganisationUser,
  resetDirectChildOrganisationUserInvitation,
} from '@redux/directChildOrganisationAdministration/actions';
import { selectDirectChildOrganisationUserInvitation } from '@redux/directChildOrganisationAdministration/selectors';
import { toDirectChildOrganisationUserInvitation } from '@redux/directChildOrganisationAdministration/invite';
import { setCurrentScreen, screens } from '../../../analytics';
import DirectChildOrganisationUserInviteWizard from './Wizard';

const NewDirectChildOrganisationUser = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const location = useLocation();
  const invitation = useSelector(selectDirectChildOrganisationUserInvitation);
  const title = t('directChildOrganisationAdministration:routes.newUser');
  const preselectedDirectChildOrganisationSlug = new URLSearchParams(location.search).get(
    'organisation',
  );

  const { hasPageActionsProvider } = usePageActions({ title, showClose: true });

  useEffect(() => {
    setCurrentScreen(screens.ADMINISTRATION_DIRECT_CHILD_ORGANISATION_USER_CREATION);
  }, []);

  useEffect(() => {
    if (invitation.status === 'success') {
      dispatch(resetDirectChildOrganisationUserInvitation());
      history.replace('/administration/child-organisation-users');
    }
  }, [dispatch, history, invitation.status]);

  useEffect(
    () => () => {
      dispatch(resetDirectChildOrganisationUserInvitation());
    },
    [dispatch],
  );

  const onSubmit = useCallback(
    values => {
      const { organisationSlug, invite } = toDirectChildOrganisationUserInvitation(values);
      dispatch(inviteDirectChildOrganisationUser(organisationSlug, invite));
    },
    [dispatch],
  );

  return (
    <>
      {!hasPageActionsProvider ? <h1>{title}</h1> : null}
      <ColumnGroup>
        <Column>
          <DirectChildOrganisationUserInviteWizard
            preselectedDirectChildOrganisationSlug={
              preselectedDirectChildOrganisationSlug || undefined
            }
            submitting={invitation.status === 'loading'}
            onSubmit={onSubmit}
          />
        </Column>
        <Column />
      </ColumnGroup>
    </>
  );
};

export default NewDirectChildOrganisationUser;
